/** @jsxImportSource @emotion/react */
import {
  CheckCircleIcon,
  ExclamationIcon,
  InformationCircleIcon,
  XCircleIcon,
} from "@heroicons/react/solid";
import tw from "twin.macro";

const Alert = ({ title, description, variant = "danger", ...props }) => {
  return (
    <div
      tw="rounded-md p-4"
      css={[
        variant === "warning" && tw`bg-yellow-50`,
        variant === "danger" && tw`bg-red-50`,
        variant === "success" && tw`bg-green-50`,
        variant === "info" && tw`bg-blue-50`,
      ]}
      {...props}
    >
      <div tw="flex">
        <div
          tw="flex-shrink-0"
          css={[
            variant === "warning" && tw`text-yellow-400`,
            variant === "danger" && tw`text-red-400`,
            variant === "success" && tw`text-green-400`,
            variant === "info" && tw`text-blue-400`,
          ]}
        >
          {variant === "warning" && <ExclamationIcon tw="h-5 w-5" />}
          {variant === "danger" && <XCircleIcon tw="h-5 w-5" />}
          {variant === "success" && <CheckCircleIcon tw="h-5 w-5" />}
          {variant === "info" && <InformationCircleIcon tw="h-5 w-5" />}
        </div>
        <div tw="ml-3">
          <h3
            tw="text-sm font-medium"
            css={[
              variant === "warning" && tw`text-yellow-800`,
              variant === "danger" && tw`text-red-800`,
              variant === "success" && tw`text-green-800`,
              variant === "info" && tw`text-blue-800`,
            ]}
          >
            {title}
          </h3>
          {description && (
            <div
              tw="mt-2 text-sm"
              css={[
                variant === "warning" && tw`text-yellow-700`,
                variant === "danger" && tw`text-red-700`,
                variant === "success" && tw`text-green-700`,
                variant === "info" && tw`text-blue-700`,
              ]}
            >
              {description}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Alert;
